
















import { Component, Ref, Vue } from 'nuxt-property-decorator'
import MobileHeader from './MobileHeader.vue'

@Component({
  components: {
    MobileHeader,
  },
})
export default class MobileLayout extends Vue {
  /* Data */
  showMenu: boolean = false

  /* Refs */

  /* Event handlers */
  onToggleFilters() {

  }

  onToggleMenu() {
    this.showMenu = !this.showMenu
  }
}
